import React from 'react';
import PropTypes from 'prop-types';
import { BundleRoute } from '@saucelabs/sl-component-router';
import { LoginRequiredContainer } from '@saucelabs/sl-container-authentication';


const importTunnels = () => import(/* webpackChunkName: "tunnels" */ './containers/TunnelsContainer');


const TunnelsRoutes = ({ match }) => (
  <LoginRequiredContainer>
    <BundleRoute
      load={importTunnels}
      path={match.url}
    />
  </LoginRequiredContainer>
);

TunnelsRoutes.propTypes = {
  match: PropTypes.object.isRequired,
};

export default TunnelsRoutes;
export { TunnelsRoutes };
